import BuildingORM from "@/store/orm-axios/models/Building";
import VotingCategoryORM from "@/store/orm-axios/models/VotingCategory";

export default {
  data() {
    return {
      building: null,
    };
  },
  methods: {
    setVotingLimitRulesStoreVariables(generalDetailsEvent) {
      try {
        if (generalDetailsEvent) {
          this.$store.commit("votingLimitRules/setFreezedVotingLimitRules", generalDetailsEvent);
        } else {
          this.building = BuildingORM.find(this.meeting.building_id);

          const totalTantiemesGenerales = this.getTotalTantiemesGenerales();
          this.$store.commit(
            "votingLimitRules/setTotalTantiemesGenerales",
            totalTantiemesGenerales
          );

          const {
            plafonMajorityIsActive,
            totalTantiemesGeneralesPlafonMajority,
            article22IsActive,
            totalTantiemesGeneralesArticle22,
          } = this.setPlafonMajorityAndArticle22StoreVariablesAndGetInfo(totalTantiemesGenerales);

          var totalTantiemesGeneralesUsed = totalTantiemesGenerales;
          if (plafonMajorityIsActive) {
            totalTantiemesGeneralesUsed = totalTantiemesGeneralesPlafonMajority;
          } else if (article22IsActive) {
            totalTantiemesGeneralesUsed = totalTantiemesGeneralesArticle22;
          }
          this.setPovoirsStoreVariables(totalTantiemesGeneralesUsed);
        }
      } catch (err) {
        console.error(err);
        this.$swal(this.alertError());
      }
    },
    getTotalTantiemesGenerales() {
      try {
        var votingCategories = VotingCategoryORM.query()
          .where("is_charge_generale", 1)
          .with("building_owner_voting_rights")
          .first();
        var totalTantiemes = 0;
        votingCategories.building_owner_voting_rights.forEach(votingRight => {
          totalTantiemes += votingRight.parts;
        });
        return this.formatNumber(totalTantiemes);
      } catch {
        return 0;
      }
    },
    setPlafonMajorityAndArticle22StoreVariablesAndGetInfo(totalTantiemesGenerales) {
      const plafonMajorityIsActive =
        this.building.with_majority && !this.building.article22 ? true : false;
      this.$store.commit("votingLimitRules/setPlafonMajorityIsActive", plafonMajorityIsActive);
      const article22IsActive =
        this.building.with_majority && this.building.article22 ? true : false;
      this.$store.commit("votingLimitRules/setArticle22IsActive", article22IsActive);

      if (!plafonMajorityIsActive && !article22IsActive) {
        return { plafonMajorityIsActive, article22IsActive };
      }

      if (plafonMajorityIsActive) {
        var totalTantiemesGeneralesPlafonMajority = this.getTotalTantiemesGeneralesPlafonMajorityOrArticle22AndSetStoreVariables(
          totalTantiemesGenerales,
          "plafon"
        );
        this.$store.commit(
          "votingLimitRules/setTotalTantiemesGeneralesPlafonMajority",
          totalTantiemesGeneralesPlafonMajority
        );

        var plafonMajorityText = this.building.with_majority_text;
        this.$store.commit("votingLimitRules/setPlafonMajorityText", plafonMajorityText);

        return { plafonMajorityIsActive, totalTantiemesGeneralesPlafonMajority };
      } else if (article22IsActive) {
        var totalTantiemesGeneralesArticle22 = this.getTotalTantiemesGeneralesPlafonMajorityOrArticle22AndSetStoreVariables(
          totalTantiemesGenerales,
          "article22"
        );
        this.$store.commit(
          "votingLimitRules/setTotalTantiemesGeneralesArticle22",
          totalTantiemesGeneralesArticle22
        );

        return { article22IsActive, totalTantiemesGeneralesArticle22 };
      }
    },
    getTotalTantiemesGeneralesPlafonMajorityOrArticle22AndSetStoreVariables(
      totalTantiemesGenerales,
      type
    ) {
      try {
        if (type == "plafon") {
          var plafonMajorityTantiemes = this.getPlafonMajorityTantiemesAndSetStoreVariables(
            totalTantiemesGenerales
          );
        }

        var groupedVotingRights = this.getGroupedVotingRights();

        var totalTantiemes = 0;
        for (let [key, votingRights] of Object.entries(groupedVotingRights)) {
          var individualTantiemes = 0;
          votingRights.forEach(votingRight => {
            individualTantiemes += votingRight.parts;
          });
          // main functionality ..
          if (type == "article22") {
            if (individualTantiemes <= totalTantiemesGenerales / 2) {
              totalTantiemes += individualTantiemes;
            } else {
              var reducedMandateTantiemesArticle22 = totalTantiemesGenerales - individualTantiemes;
              var buildingOwnerIdArticle22 =
                votingRights[0].buildingOwnerBuildingLot.buildingOwner.id;

              totalTantiemes += reducedMandateTantiemesArticle22;
              this.setArticle22StoreVariables(
                buildingOwnerIdArticle22,
                reducedMandateTantiemesArticle22
              );
            }
          } else if (type == "plafon") {
            if (individualTantiemes <= plafonMajorityTantiemes) {
              totalTantiemes += individualTantiemes;
            } else {
              totalTantiemes += plafonMajorityTantiemes;
            }
          }
        }

        return this.formatNumber(totalTantiemes);
      } catch {
        return 0;
      }
    },
    getGroupedVotingRights() {
      var votingCategories = VotingCategoryORM.query()
        .where("is_charge_generale", 1)
        .with("building_owner_voting_rights.buildingOwnerBuildingLot.buildingOwner")
        .first();

      return this.$_.groupBy(votingCategories.building_owner_voting_rights, item => {
        if (item.buildingOwnerBuildingLot.buildingOwner.id)
          return "owner-" + item.buildingOwnerBuildingLot.buildingOwner.id;
      });
    },
    getPlafonMajorityTantiemesAndSetStoreVariables(totalTantiemesGenerales) {
      var plafonMajorityTantiemes = this.getPlafonMajorityTantiemes(totalTantiemesGenerales);
      this.$store.commit("votingLimitRules/setPlafonMajorityTantiemes", plafonMajorityTantiemes);
      return plafonMajorityTantiemes;
    },
    getPlafonMajorityTantiemes(totalTantiemesGenerales) {
      var plafonMajorityTantiemes = (totalTantiemesGenerales * this.building.majority_parts) / 100;
      return this.formatNumber(plafonMajorityTantiemes);
    },
    setArticle22StoreVariables(buildingOwnerIdArticle22, reducedMandateTantiemesArticle22) {
      this.$store.commit("votingLimitRules/setBuildingOwnerIdArticle22", buildingOwnerIdArticle22);
      this.$store.commit(
        "votingLimitRules/setReducedMandateTantiemesArticle22",
        reducedMandateTantiemesArticle22
      );
    },

    setPovoirsStoreVariables(totalTantiemesGeneralesUsed) {
      const votingLimitIsActive = this.building.voting_limit ? true : false;
      this.$store.commit("votingLimitRules/setVotingLimitIsActive", votingLimitIsActive);

      if (!votingLimitIsActive) {
        return;
      }

      this.$store.commit(
        "votingLimitRules/setVotingLimitOperator",
        this.building.voting_limit_operator
      );
      this.$store.commit(
        "votingLimitRules/setVotesLimitPerMandate",
        this.building.votes_per_mandate
      );
      this.$store.commit(
        "votingLimitRules/setVotingIncludesMandate",
        this.building.voting_includes_mandates ? true : false
      );

      var tantiemesLimitPerMandate = this.formatNumber(
        (totalTantiemesGeneralesUsed * this.building.parts_per_mandate) / 100
      );
      this.$store.commit("votingLimitRules/setTantiemesLimitPerMandate", tantiemesLimitPerMandate);
    },
  },
};
